export enum SubmissionReviewStatus {
  Pending = 'pending',
  InProgress = 'in_progress',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Withdrawn = 'withdrawn',
  Removed = 'removed',
  Public = 'public',
  Embargo = 'embargo',
  PendingUpdates = 'pending-updates',
  PendingWithdrawal = 'pending_withdraw',
}
